import React, { useState } from 'react';
import { Link, Navigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import OperationalTab from '../components/admin/OperationalTab';

type AdminView = 'overview';

const TABS: { key: AdminView; label: string }[] = [{ key: 'overview', label: 'Operations' }];

const AdminPage: React.FC = () => {
  const { isAuthenticated, isLoading } = useAuth();
  const [view, setView] = useState<AdminView>('overview');

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500 dark:border-blue-400" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/account" replace />;
  }

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      <div className="sticky top-0 z-10 bg-gray-50/95 dark:bg-gray-900/95 backdrop-blur border-b border-gray-200 dark:border-gray-700">
        <div className="max-w-4xl mx-auto px-4 pt-4 pb-3 sm:pt-6">
          <div className="flex items-center justify-between mb-4">
            <h1 className="text-xl sm:text-2xl font-semibold text-gray-900 dark:text-gray-100">
              Admin
            </h1>
            <Link
              to="/account"
              className="text-sm text-blue-500 dark:text-blue-400 font-medium"
            >
              Back to account
            </Link>
          </div>

          {/* Segmented control — works well as a mobile tab bar */}
          <div className="grid grid-cols-1 gap-1 p-1 rounded-lg bg-gray-200 dark:bg-gray-800">
            {TABS.map((tab) => (
              <button
                key={tab.key}
                onClick={() => setView(tab.key)}
                className={`py-2 px-1 rounded-md text-xs sm:text-sm font-medium transition-colors min-h-[40px] ${
                  view === tab.key
                    ? 'bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100 shadow-sm'
                    : 'text-gray-500 dark:text-gray-400'
                }`}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-4 py-4 sm:py-6">
        {view === 'overview' && <OperationalTab />}
      </div>
    </div>
  );
};

export default AdminPage;
